import { j as m } from "../../../../jsx-runtime-B3iL8JI7.js";
import e from "../../../../utilities/tw.js";
import p from "../../../../tailwindConfig/bclTwMerge.js";
const b = ({
  id: r,
  label: l,
  isDisplayOnly: a = !1,
  showDisabled: s = !1,
  showErrorState: o = !1,
  onClick: t
}) => {
  let f = p(
    e`w-fit cursor-pointer text-caption-xs`,
    o && e`text-error`,
    s && !a && e`text-disabled`,
    (a || s) && e`pointer-events-none cursor-default`
  );
  return /* @__PURE__ */ m.jsx(
    "label",
    {
      htmlFor: r,
      className: f,
      "data-testid": `${r}-label`,
      onClick: () => t == null ? void 0 : t(),
      children: l
    }
  );
};
export {
  b as default
};
